import { AppProps } from 'next/app';
import Head from 'next/head';
import '../styles/globals.css';
import { Provider } from 'react-redux';
import { store } from '../store/store';
import Router from 'next/router';
import nProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Toaster } from 'react-hot-toast';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { useEffect } from 'react';
import { handleAsyncBookingEvent } from '../store/Bookings/actions';
import { Booking } from '@deliveries-app/models';
import api from '../lib/axios';

declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo: Echo;
  }
}

const PUSHER_APP_KEY = process.env.NEXT_PUBLIC_PUSHER_APP_KEY;

function CustomApp({ Component, pageProps }: AppProps) {
  nProgress.configure({
    minimum: 0.3,
    easing: 'ease',
    speed: 800,
    showSpinner: false,
  });

  Router.events.on('routeChangeStart', () => nProgress.start());
  Router.events.on('routeChangeComplete', () => nProgress.done());
  Router.events.on('routeChangeError', () => nProgress.done());

  useEffect(() => {
    window.Pusher = Pusher;
    window.Echo = new Echo({
      broadcaster: 'pusher',
      key: PUSHER_APP_KEY,
      cluster: 'ap4',
      forceTLS: true,
      authorizer: (channel, options) => {
        return {
          authorize: (socketId, callback) => {
            api
              .post('/api/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name,
              })
              .then((res) => {
                callback(false, res.data);
              })
              .catch((error) => {
                callback(true, error);
              });
          },
        };
      },
    });
  }, []);

  return (
    <Provider store={store}>
      <Head>
        <title>Welcome to dashboard!</title>
      </Head>
      <main className="app">
        <Toaster position="top-right" reverseOrder={true} />
        <Component {...pageProps} />
      </main>
    </Provider>
  );
}

export default CustomApp;
